import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Card} from 'ktm-ui';

interface IdsPolicy {
    Id:string;
    EnrollmentNote:string;
};

export default KTMScreen({name:"planadmin.policy.edit-note"}, class extends React.Component<{policy_id:string}> {

    data:{
        dsPolicy:IdsPolicy;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsPolicy";
        await KTMApi.start(screen,{
            "@policy_id":this.props.policy_id,
        });
        screen.title = "Edit Enrollment Note";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.details)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Edit Enrollment Note"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Display field={field("EnrollmentNote")}/>
            </Card>
        );
    }

    async submit({screen}:ActionEvent){
        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note:  this.data.dsPolicy.EnrollmentNote,
            Action: "Policy Edit Enrollment Note",
            PolicyId: this.props.policy_id,
            }),
         };
        await KTMApi.action(screen,"submit",{
            "@dsPolicy.EnrollmentNote":this.data.dsPolicy.EnrollmentNote,
            "@policy_id":this.props.policy_id,
        }).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        })
        screen.close({"continue":true});
    }

});
